import { ApplicationConfig, provideAppInitializer, provideZonelessChangeDetection } from '@angular/core';
import { icons, provideLucideIcons } from '@lucide/angular';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app.routes';
import { provideSharedUi } from './shared/shared-imports';
import { CrimsonNoirPreset } from './shared/primeng-color-preset';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { credentialsInterceptor } from './core/shared/interceptors/credentials.interceptor';
import { unauthorizedInterceptor } from './core/shared/interceptors/unauthorized.interceptor';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { initializeAuthSession } from './core/auth/auth.service';
import { CachedTranslateLoader } from './core/i18n/cached-translate.loader';
import { initializeTranslations } from './core/i18n/initialize-translations';
import { DEFAULT_LANGUAGE } from './core/i18n/language-storage';

export const appConfig: ApplicationConfig = {
  providers: [
    provideLucideIcons(...Object.values(icons)),
    provideAnimationsAsync(),
    provideRouter(appRoutes),
    provideAppInitializer(initializeTranslations),
    provideAppInitializer(initializeAuthSession),
    provideSharedUi(),
    providePrimeNG({
      theme: {
        preset: CrimsonNoirPreset,
        options: {
          darkModeSelector: '.my-app-dark',
        },
      },
    }),
    MessageService,
    provideZonelessChangeDetection(),
    provideHttpClient(withInterceptors([credentialsInterceptor, unauthorizedInterceptor])),
    provideTranslateService({
      lang: DEFAULT_LANGUAGE,
      fallbackLang: DEFAULT_LANGUAGE,
      loader: {
        provide: TranslateLoader,
        useClass: CachedTranslateLoader,
      },
    }),
  ],
};
